export default {"wrapper":"Rl7iK","table":"pvE1d","head":"eOfTH","th":"_73TQF","body":"KznMb","td":"iZrZf","verticalLine":"-rtry"};